import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Step } from 'react-joyride'
import InfoBox from 'ui/components/ModuleHeader/InfoBox'
import Tour from 'ui/components/Tour/Tour'

export default function OptimizeWIPTour() {
  const { t } = useTranslation()

  const [runTour, setRunTour] = useState<null | number>(null)

  const steps: Step[] = [
    {
      target: 'tour-target-welcome',
      content: (
        <Typography variant="h6">
          {t(
            `Prepare your production plan before publishing it to the Production Plan module. This module mirrors the Production Plan module functionality, with an additional publish button.\n\nOperations staff only see published plans. Optimizations here are logged as 'Draft production plan' optimizations, which is reflected in the notification center.`
          )}
        </Typography>
      ),
      title: t('Draft production plan'),
    },
    {
      target: 'tour-target-optimize',
      content: (
        <Typography variant="h6">
          {t(
            `Optimizations in this module apply locally only. Use the 'Publish Production Plan' button to deploy to the Production Plan module.`
          )}
        </Typography>
      ),
      title: t('Optimize production plan'),
    },
    {
      target: 'tour-target-publish',
      content: (
        <div>
          <Typography variant="h6">
            <b>{`${t(`Publishes the production plan to the Production Plan module.`)}`}</b>
          </Typography>
          <br />
          <Typography variant="h6">
            {t(
              'Only the latest successful optimization can be published; failed optimizations are excluded.\n\nClicking the button opens a confirmation dialog showing which optimization will replace the current production plan.'
            )}
          </Typography>
        </div>
      ),
      title: t('Publish production plan'),
    },
  ]

  return (
    <>
      <Tour run={runTour !== null} setRunState={(state: boolean) => setRunTour(state ? 0 : null)} steps={steps} />
      <InfoBox onInfoButtonClick={() => setRunTour(0)} />
    </>
  )
}
